import { Button } from "@mui/material";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import Panel from "@/layout/Panel";
import PanelTitle from "@/layout/PanelTitle";

export const NotFoundComponent = ({ children }: { children: ReactNode }) => {
    const { t } = useTranslation();

    const navigate = useNavigate();

    return (
        <Panel title={<PanelTitle title={""} />}>
            <div className="w-ful min-h-96 h-[70%]  grid place-content-center">
                <div className="flex flex-col  items-center">
                    <img src="/images/NotFound.png" alt="" />
                    <div className=" ml-2 flex flex-col items-center -translate-y-20">
                        {children}
                        <Button
                            variant="contained"
                            color="primary"
                            className="!mt-4"
                            size="large"
                            onClick={() => {
                                navigate("/");
                            }}
                        >
                            {t("home")}
                        </Button>
                    </div>
                </div>{" "}
            </div>
            <div className="flex flex-col items-center gap-2 justify-center h-full"></div>
        </Panel>
    );
};
